import React, { useState, useRef, useEffect, startTransition } from "react";
import PropTypes from "prop-types";
import { Input } from "@cars24/turbo-web/lib/input";
import RegNoPrefix from "./images/reg-no-prefix.svg";
import { formatInputValue } from "../input-reg-no/selector";
import { debounce } from "lodash";
import { NUMBER } from "../../../constants/app-constants";

const InputRegNoPlateV2 = React.memo(({
    placeholder = "DL 12 AA 1234",
    onChange,
    ...rest
}) => {
    const [value, setValue] = useState("");

    const debouncedOnChangeRef = useRef(
        debounce((newVal) => {
            startTransition(() => {
                onChange(newVal);
            });
        }, NUMBER.TWO_HUNDRED)
    );

    useEffect(() => {
        return () => {
            debouncedOnChangeRef.current.cancel();
        };
    }, []);

    const handleOnChange = (e) => {
        const val = e.target.value;
        const newVal = (val || "").replace(/[^a-z0-9]/gi, "");

        if (newVal.length > NUMBER.TEN) {
            return;
        }
        const sanitizedValue = formatInputValue({ inputValue: val });
        if (sanitizedValue !== value) {
            setValue(sanitizedValue);
        }
        debouncedOnChangeRef.current(newVal);
    };

    return (
        <Input
            type="text"
            transformValue="uppercase"
            placeholder={placeholder}
            value={value}
            prefix={<img width={"41px"} height={"58px"} src={RegNoPrefix} alt="Reg no" />}
            onChange={handleOnChange}
            {...rest}
        />
    );
});

InputRegNoPlateV2.propTypes = {
    placeholder: PropTypes.string,
    onChange: PropTypes.func
};

export default InputRegNoPlateV2;
